import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@knockrentals/knock-shared-web-v2';
import { DialogContent } from '@material-ui/core';
import { FeatureDialogActions } from '../../../../../knock-design-system';
import { useImportProperties } from './use-import-properties';
import { PropertiesImportDropzone } from './PropertiesImportDropzone';
import { PropertiesImportStatus } from './PropertiesImportStatus';
import { IMPORT_STATUS } from './constants';

export const IMPORT_PRIMARY_BUTTON_TEXT = 'Import Data';

const ImportProperties = ({ closeDialog }) => {
  const {
    clearErrorMessage,
    fileInputRef,
    fileName,
    fileSize,
    handleDropTargetClick,
    handleImportProperties,
    handleFile,
    importStatus,
    invalidFileMessage,
    removeUploadedFile,
  } = useImportProperties();

  const isImportButtonDisabled = importStatus !== IMPORT_STATUS.READY;

  return (
    <React.Fragment>
      <DialogContent>
        <Typography color="secondary.700" variant="subtitle2">
          File
        </Typography>
        {importStatus === IMPORT_STATUS.IDLE ? (
          <PropertiesImportDropzone
            clearErrorMessage={clearErrorMessage}
            fileInputRef={fileInputRef}
            handleDropTargetClick={handleDropTargetClick}
            handleFile={handleFile}
            invalidFileMessage={invalidFileMessage}
          />
        ) : (
          <PropertiesImportStatus
            fileName={fileName}
            fileSize={fileSize}
            importStatus={importStatus}
            removeUploadedFile={removeUploadedFile}
          />
        )}
      </DialogContent>
      <FeatureDialogActions
        isPrimaryButtonDisabled={isImportButtonDisabled}
        primaryButtonText={IMPORT_PRIMARY_BUTTON_TEXT}
        primaryButtonOnClick={handleImportProperties}
        tertiaryButtonOnClick={closeDialog}
      />
    </React.Fragment>
  );
};

ImportProperties.propTypes = {
  closeDialog: PropTypes.func,
};

export default ImportProperties;
